import PropTypes from 'prop-types'
import React from 'react'

const AdditionalConfigRequiredOption = ({ isReceptionDesk }) => {
  const contextLabel = isReceptionDesk ? 'creados con la plantilla Mesa de partes' : 'de la entidad'
  return (
    <>
      Será <span className="font-bold">obligatorio y fijo</span> para todos los formularios {contextLabel}.
    </>
  )
}

export default AdditionalConfigRequiredOption

AdditionalConfigRequiredOption.propTypes = {
  isReceptionDesk: PropTypes.bool
}
